import React from "react";
import "../styles/LigneInterElement.css"

function LigneInterElement() {
    return(
        <div className="divLigne">
            <div className="ligne"></div>
        </div>
    );
}

export default LigneInterElement;